import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationResourcesService } from './application-resources.service';
import { BaseResourceService } from './base/base-resource.service';
import { ApplicationResourceType } from './models/application-resource';
import { DynamicFormContent } from './models/page-resource-content';

@Injectable({ providedIn: 'root' })
export class EditFormsResourceService extends BaseResourceService<DynamicFormContent> {
  type: ApplicationResourceType = 'EDITFORM';

  constructor(
    _applicationResourceService: ApplicationResourcesService,
    private router: Router
  ) {
    super(_applicationResourceService);
  }
}
